import { render, staticRenderFns } from "./PayIcon.vue?vue&type=template&id=79239d7b&scoped=true&"
import script from "./PayIcon.vue?vue&type=script&lang=js&"
export * from "./PayIcon.vue?vue&type=script&lang=js&"
import style0 from "./PayIcon.vue?vue&type=style&index=0&id=79239d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79239d7b",
  null
  
)

export default component.exports